import React, { useContext } from "react";
import { Alert, Spin } from "antd";
import { AuthContext } from "../context/AuthProvider";
import RepairTicketNegotiationView from "./RepairTicketNegotiationView";
import { BID_COMPARISON_SCREENSHOT_TICKET_ID } from "../helpers/bidComparisonScreenshotMock";
import { getDebugMode } from "../helpers/constants";

/**
 * Sample bid comparison for marketing screenshots. Requires the same URL debug flag
 * as the rest of the app: ?debug=true or ?debug
 *
 * Example: /demo/bid-comparison?debug=true
 * Cleaner frame: /demo/bid-comparison?debug=true&clean=true
 */
const BidComparisonScreenshotPage = () => {
  const { user } = useContext(AuthContext);

  if (!user?.uid) {
    return (
      <div style={{ padding: 64, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!getDebugMode()) {
    return (
      <div style={{ maxWidth: 560, margin: "48px auto", padding: 24 }}>
        <Alert
          type="info"
          showIcon
          message="Bid comparison preview"
          description={
            <>
              Turn on URL debug mode to load sample bids (same as other debug
              demos): add <code>?debug=true</code> or <code>?debug</code> to
              this page&apos;s URL. For exports without the preview banner, add{" "}
              <code>&amp;clean=true</code> as well (still with{" "}
              <code>debug</code>).
            </>
          }
        />
      </div>
    );
  }

  return (
    <RepairTicketNegotiationView
      ticketId={BID_COMPARISON_SCREENSHOT_TICKET_ID}
      user={user}
    />
  );
};

export default BidComparisonScreenshotPage;
